module.exports = __webpack_public_path__ + "static/jasonbcox-fd9fbe2d03146a33fb4605b630856087.jpg";